import { atom } from 'recoil';

export const defaultSignatureKey = atom<string | null>({
  key: `defaultSignatureKey`,
  default: null,
});

export default defaultSignatureKey;
